import sender from "@verity/extension/external-message/sender";
import { dispatchProxyMessage } from "@verity/extension/proxy-message/external";
import apiClient from "../../helpers/api-client";

export function getExtensionVersionFromExtension(extensionId: string) {
	if (window.chrome) {
		return sender
			.sendMessage(
				{
					function: "getExtensionVersion",
					extensionId: extensionId,
					params: undefined,
				},
				2000,
			)
			.catch(() => undefined);
	} else {
		return dispatchProxyMessage("getExtensionVersion", undefined);
	}
}

export async function isExtensionInstalled(
	extensionId: string,
	setIsVersionSupported?: (val: boolean) => void,
): Promise<boolean> {
	try {
		let extensionVersion: string | undefined;
		if (window.chrome) {
			extensionVersion = await sender.sendMessage(
				{
					function: "getExtensionVersion",
					extensionId: extensionId,
					params: undefined,
				},
				2000,
			);
		} else {
			extensionVersion = await dispatchProxyMessage("getExtensionVersion", undefined);
		}
		if (typeof extensionVersion === "string") {
			const isVersionSupported = (await apiClient.platformInfo.isVersionSupported(extensionVersion)).versionSupported;
			if (setIsVersionSupported) {
				setIsVersionSupported(isVersionSupported);
			}
			return isVersionSupported;
		}
	} catch (error) {
		console.warn("sendMessage to YuJa Verity extension failed.");
	}
	return false;
}

export async function isExtensionAuthenticated(): Promise<boolean> {
	// try {
	// 	return await apiClient.authentication.isAuthenticated();
	// } catch (error) {
	// 	console.error(error);
	// }
	// return false;
	return new Promise((resolve, _reject) => {
		resolve(true);
	});
}

export async function isExtensionInstalledAndAuthenticated(
	extensionId: string,
	setIsVersionSupported?: (val: boolean) => void,
): Promise<boolean> {
	let hasExtension = false;
	let isAuthenticated = false;

	await isExtensionInstalled(extensionId, setIsVersionSupported).then(
		(res) => {
			hasExtension = res;
		},
		() => {
			hasExtension = false;
		},
	);
	if (hasExtension) {
		await isExtensionAuthenticated().then(
			(res) => {
				isAuthenticated = res;
			},
			() => {
				isAuthenticated = false;
			},
		);
	}

	return hasExtension && isAuthenticated;
}

export function isIncognitoAllowed(extensionId: string): Promise<boolean> {
	if (window.chrome) {
		return sender.sendMessage(
			{
				function: "isIncognitoAllowed",
				extensionId,
				params: undefined,
			},
			5000,
		);
	} else {
		return dispatchProxyMessage("isIncognitoAllowed", undefined);
	}
}

export function isInManagedGuestSession(extensionId: string): Promise<boolean> {
	try {
		if (window.chrome) {
			return sender.sendMessage(
				{
					function: "isInManagedGuestSession",
					extensionId,
					params: undefined,
				},
				5000,
			);
		} else {
			return dispatchProxyMessage("isInManagedGuestSession", undefined);
		}
	} catch (e) {
		console.error(e);
		return Promise.resolve(false);
	}
}

export function compatibilityCheckInProgress(extensionId: string): Promise<boolean> {
	if (window.chrome) {
		return sender.sendMessage(
			{
				function: "compatibilityCheckInProgress",
				extensionId,
				params: undefined,
			},
			5000,
		);
	} else {
		return dispatchProxyMessage("compatibilityCheckInProgress", undefined);
	}
}
